import MelhousBoard from "../Components/MelhousBoard";
import MelhousPage from "../Components/MelhousPage";
import ModelMelhousRequest from "../models/ModelMelhousRequest";
import { VIEW_REQUESTS } from "../constants";

function MelhousRequests() {
  return (
    <MelhousPage view={VIEW_REQUESTS}>
      <MelhousBoard model={ModelMelhousRequest} />
    </MelhousPage>
  );
}

export default MelhousRequests;
